import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { Field as FormField } from 'web-ui-components/lib/molecules/forms';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';

const AddManuallyComponent = ({ type, onAddManuallyClick, isAddMunuallyClicked }) => (
  <Content>
    {content => (
      <Field name={`${type}.Postcode`} subscription={{ touched: true, error: true }}>
        {() => (
          <FormField>
            <NavigationButton.Tertiary
              onClick={e => {
                e.preventDefault();
                onAddManuallyClick(!isAddMunuallyClicked);
              }}
              labelText={isAddMunuallyClicked ? content.FindByPostCode : content.addManually}
            />
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

AddManuallyComponent.propTypes = {
  onAddManuallyClick: PropTypes.func,
  isAddMunuallyClicked: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired
};

export default AddManuallyComponent;
